import IssueOwnershipCertificateSelfRedeemed from './IssueOwnershipCertificateSelfRedeemed'

export default IssueOwnershipCertificateSelfRedeemed
